import {pageInfo, initUpdate, editData, addWhiteListPageInfo, addData} from "../api";
import { storageList, goodsCategory} from '../../../../api'

const purchOrderWhiteList = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initUpdateObj: null,
    updateResp: null,
    storageObj:null,
    purchOrderTotal: null,
    purchOrderResp: null,
    addSubmitResp:null,
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    UPDATE_INIT_DATA(state, data){
      state.initUpdateObj = data.obj;
    },
    UPDATE_DATA(state, data){
      state.updateResp = data;
    },
    ADD_DATA(state, data){
      state.addSubmitResp = data;
    },
    STORAGE(state, data){
      state.storageObj = data.obj;
      state.storageObj = (data.obj || []).map(item=> ({...item, btList:[false]}));
    },
    GOODS_CATEGORY(state, data){
      state.goodsCategoryObj = data.obj || [];
    },
    PURCH_ORDER_PAGEINFO(state, data){
      state.purchOrderTotal = data.total;
      state.purchOrderResp = data.obj || [];
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //修改初始化
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('UPDATE_INIT_DATA', resp);
    },
    //编辑提交
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('UPDATE_DATA', resp);
    },
    //新增提交
    async addSubmit({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //子库下拉框
    async storage({ commit }, obj) {
      let resp = await storageList(obj);
      commit('STORAGE', resp);
    },
    //子库下拉框
    async goodsCategory({ commit }, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },
    //查询退货单数据
    async addWhiteListPageInfo({ commit }, obj) {
      let resp = await addWhiteListPageInfo(obj);
      commit('PURCH_ORDER_PAGEINFO', resp);
    },
  }
}
export default purchOrderWhiteList



// WEBPACK FOOTER //
// ./src/page/md/purchOrderWhiteList/store/purchOrderWhiteList.store.js